import type { ComponentChildren } from 'preact'
import { ServicesSidebar } from './ServicesSidebar'
import { MobileServicesAccordion } from './MobileServicesAccordion'
import {
  HEADER_HEIGHT_PX,
  MOBILE_ACCORDION_HEIGHT_PX,
} from '../../../constants'
import { getConfig } from '../../../config'

interface ContentProps {
  children: ComponentChildren
  showSidebar?: boolean
}

export function Content({ children, showSidebar = true }: ContentProps) {
  const { commercialSectionEnabled } = getConfig()

  const shouldShowSidebar = showSidebar && commercialSectionEnabled

  return (
    <div
      className={`w-full flex-1`}
      style={{
        paddingTop: HEADER_HEIGHT_PX,
      }}
    >
      <div
        className='flex flex-col lg:flex-row w-full'
        style={{
          minHeight: `calc(100dvh - ${HEADER_HEIGHT_PX})`,
        }}
      >
        <div className='flex-1 w-full shadow-lg lg:shadow-r-lg bg-white px-6 sm:px-5 md:px-6 lg:px-4 xl:px-6 pt-4 pb-4 lg:pb-10 flex gap-2 justify-center relative z-10 overflow-y-auto flex-col items-center'>
          <div
            className='max-w-4xl w-full flex-1 flex flex-col'
            style={{
              minHeight: `calc(100dvh - ${HEADER_HEIGHT_PX} - ${MOBILE_ACCORDION_HEIGHT_PX})`,
            }}
          >
            {children}
          </div>
          {shouldShowSidebar && <MobileServicesAccordion />}
        </div>
        {shouldShowSidebar && (
          <div className='w-full lg:w-[400px] xl:w-[450px] 2xl:w-[500px] lg:flex-shrink-0 px-2 lg:px-3 xl:px-4 pt-4 pb-8 lg:pb-10 justify-center bg-cencert-bg-gray hidden lg:flex'>
            <ServicesSidebar />
          </div>
        )}
      </div>
    </div>
  )
}
